import { IconSizes, type NewcoreIcon } from '@newcore/icons';
import { cn } from '@newcore/ui/cn';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Text } from '@newcore/ui/typography';

interface TopNavItemProps {
  label: string;
  icon: NewcoreIcon;
  selected?: boolean;
  onClick: () => void;
}

export function TopNavItem({
  label,
  icon: Icon,
  selected = false,
  onClick,
}: TopNavItemProps) {
  return (
    <button
      type='button'
      onClick={onClick}
      aria-label={label}
      aria-current={selected ? 'page' : undefined}
      className={cn(
        'flex h-9 shrink-0 items-center gap-2 rounded-full px-2 transition-colors lg:px-3',
        selected
          ? 'bg-tertiary/50 text-primary'
          : 'text-quaternary hover:bg-tertiary/50 hover:text-primary'
      )}
    >
      <Icon
        size={IconSizes.MD}
        strokeWidth={selected ? 2 : 1.75}
        className='shrink-0'
        aria-hidden='true'
      />
      <Text
        weight={FontWeights.SEMIBOLD}
        className='sr-only truncate whitespace-nowrap lg:not-sr-only'
      >
        {label}
      </Text>
    </button>
  );
}
